// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessDepot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.588 3.5c0-.276.215-.5.48-.5h16.32a.49.49 0 0 1 .48.5V4a.49.49 0 0 1-.48.5h-2.4v3.152c1.058.288 1.772.62 2.225.882.445.257.655.764.655 1.294V20c0 .552-.43 1-.96 1H4.548c-.53 0-.96-.448-.96-1V9.828c0-.53.21-1.037.655-1.294.453-.263 1.167-.594 2.225-.882V4.5h-2.4a.49.49 0 0 1-.48-.5zm2.88 6.231a7.737 7.737 0 0 0-.96.376V19h.96zM7.908 19h3.6V9.008c-1.485.035-2.669.177-3.6.359zm3.6-14.5h-3.6v2.836a24.127 24.127 0 0 1 3.6-.328zm1.44 4.508V19h3.6V9.367c-.931-.182-2.116-.324-3.6-.359zm3.6-4.508h-3.6v2.508c1.423.031 2.613.156 3.6.328zm1.44 5.231V19h.96v-8.893a7.73 7.73 0 0 0-.96-.376z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessDepot;
